import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

export const dummyDropDown = [
    { label: 'exam registration', value: 'exam registration' },
    { label: 'Misc. Charges', value: 'Misc. Charges' },
    { label: 'security', value: 'security' },
  ]
  export const dummyDropDown2 = [
    { label: '743516', value: '743516' },
    { label: '812341', value: '812341' },
    { label: '567430', value: '567430' },
  ]
 
 export const options = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
  ];
  export const selectStyles = {
  
    borderRadius: '12px',
    height: '30px',
    color: '#B0B0B0',
    fontSize: '14px',
    fontFamily: 'Inter',
    lineHeight: '20px',
    
  }

  export const getAllOtherChargesConfigs = async (applicationDetails) => {
    try {
      if(!applicationDetails?.applicationId) return []
      const response = await fetchAllPromisedData(
        endpoint.concessionConfigConc.getAll,
        true
      );
      if (response && response.code === 200) {
          console.log(applicationDetails, "applicationDetails")
        const otherChargesConfig = response?.data?.filter(
          (item) => item?.chargeType === "OTHER"
        );
        
        const _customConfig = otherChargesConfig.find(
          (item) =>
            item.businessAreas.includes(
              applicationDetails.businessAreaId
            ) &&
            item?.academicGroups?.includes(applicationDetails.academicGroupId)
             &&
            item?.terms?.includes(applicationDetails.termId)
        );

        return (_customConfig);
      } else {
        failureToast("Failed to fetch Custom Config Data");
      }
    } catch (error) {
      failureToast("Failed to fetch Custom Config Data");
    }
  };